/*
  EU/UK store notice (International Anthem EU/UK store, run by K7).
  Loaded on every page by sections/ia-k7-nudge.liquid, which also sets
  window.IAK7 = { store, map } where map is "US handle" -> "K7 handle".

  Only for visitors in the EU or the UK (or anyone with ?k7test=1 in the URL):
  - product page: fills the box placed by snippets/ia-k7-banner.liquid
  - quick-add picker (assets/ia-quick-add.js, .iaqa__card): a line above "See full details"
  - bags (Now Playing bag .npb__foot, site cart drawer and cart page .cart__ctas):
    "N of these are at our EU/UK store" + a button that opens K7's checkout with
    those records (formats matched by SKU, else by format name), then offers to
    take them out of this bag.
  Stock is checked live on K7 (/products/<handle>.js). If that check can't run,
  product page and picker still show the line, the bag falls back to plain links.
*/
(function () {
  if (window.__iaK7) return;
  window.__iaK7 = true;
  var cfg = window.IAK7 || {};
  var STORE = cfg.store || 'https://international-anthem.k7store.com';
  var MAP = cfg.map || {};
  var UTM = 'utm_source=us-shop&utm_medium=referral&utm_campaign=eu-uk-notice';
  var EU_UK = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];
  var TEST = /[?&]k7test=/.test(location.search);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PITCH = 'it ships from Europe, costs less to send, and you pay in your own currency.';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var css = [
    '.ia-k7{margin:1.2rem 0 0;padding:1.1rem 1.3rem;border:1px solid rgba(22,21,21,.18);border-radius:4px;font-size:13.5px;line-height:1.45;text-align:left;color:inherit;background:rgba(255,255,255,.35)}',
    '.ia-k7 p{margin:0}',
    '.ia-k7 strong{font-weight:600}',
    '.ia-k7__link{display:inline-block;margin-top:.5rem;font-weight:600;color:inherit;text-underline-offset:3px}',
    '.ia-k7__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;margin-top:.8rem;padding:0 1.2rem;border:0;box-shadow:inset 0 0 0 1.5px currentColor;background:transparent;color:inherit;font:inherit;font-weight:600;text-decoration:none;cursor:pointer}',
    '.ia-k7__btn:hover{background:rgba(22,21,21,.06)}',
    '.ia-k7__list{margin:.5rem 0 0;padding:0 0 0 1.1rem}',
    '.ia-k7__row{display:flex;gap:1.2rem;margin-top:.6rem}',
    '.ia-k7__row button{padding:0;border:0;background:none;color:inherit;font:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.ia-k7__test{margin-top:.5rem!important;font-size:12px;opacity:.7}',
    '.iaqa .ia-k7{margin:10px 0 0}',
    '.npb__foot .ia-k7{margin:0 0 14px}',
    '.cart__ctas + .ia-k7, .ia-k7 + .cart__ctas{margin-top:1rem}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* Country: Shopify's own value, else the store's suggestion endpoint (cached per visit). */
  var countryP = null;
  function inEU() {
    if (TEST) return Promise.resolve(true);
    if (countryP) return countryP;
    var known = window.Shopify && Shopify.country;
    if (known && known !== 'US') return (countryP = Promise.resolve(EU_UK.indexOf(known) > -1));
    var cached = null;
    try { cached = sessionStorage.getItem('ia-country'); } catch (e) {}
    if (cached) return (countryP = Promise.resolve(EU_UK.indexOf(cached) > -1));
    countryP = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (c) { try { sessionStorage.setItem('ia-country', c); } catch (e) {} }
        return EU_UK.indexOf(String(c || '').toUpperCase()) > -1;
      })
      .catch(function () { return false; });
    return countryP;
  }

  /* K7 product, fetched once per handle. Resolves to the product, or null if the check can't run. */
  var k7cache = {};
  function k7(handle) {
    if (!k7cache[handle]) {
      k7cache[handle] = fetch(STORE + '/products/' + handle + '.js', { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { return null; });
    }
    return k7cache[handle];
  }
  function handleFromUrl(u) { var m = String(u || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function k7url(h) { return STORE + '/products/' + h + '?' + UTM; }
  function testNote(p) {
    if (!TEST) return '';
    return '<p class="ia-k7__test">Test: ' + (p === null ? 'live stock check could not run, so this shows anyway.' : p.available ? 'live stock check worked, in stock on K7.' : 'live stock check worked, SOLD OUT on K7, so shoppers would not see this.') + '</p>';
  }

  /* One product: product page box and picker line. */
  function single(container, usHandle, place) {
    var h = MAP[usHandle];
    if (!h || container.__iaK7 === usHandle) return;
    container.__iaK7 = usHandle;
    inEU().then(function (ok) {
      if (!ok) return;
      return k7(h).then(function (p) {
        if (p && !p.available && !TEST) return;
        var box = document.createElement('div');
        box.className = 'ia-k7';
        box.innerHTML = '<p><strong>Ordering from the EU or UK?</strong> Get this from our EU/UK store: ' + PITCH + '</p>' +
          '<a class="ia-k7__link" href="' + esc(k7url(h)) + '">Shop the EU/UK store <span aria-hidden="true">&rarr;</span></a>' + testNote(p);
        place(box);
      });
    });
  }

  /* Bags: look at the cart, find the records K7 has, offer to check them out there. */
  var SKU = function (s) { return String(s || '').toUpperCase().replace(/\s+/g, '').replace(/^ROW/, '').replace(/^IA-/, '').replace(/US$/, ''); };
  var NAME = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
  function matchVariant(item, p) {
    if (!p || !p.variants) return null;
    var vs = p.variants, s = SKU(item.sku), n = NAME(item.variant_title);
    var v = s && vs.filter(function (x) { return SKU(x.sku) === s; })[0];
    if (!v && n) v = vs.filter(function (x) { return NAME(x.title) === n; })[0];
    if (!v && vs.length === 1) v = vs[0];
    return v || null;
  }
  var bagBusy = false, dismissed = '';
  function bags() {
    var spots = [];
    document.querySelectorAll('.npb__foot').forEach(function (f) { var c = f.querySelector('.npb__checkout'); if (c) spots.push({ before: c, foot: f }); });
    document.querySelectorAll('.cart__ctas').forEach(function (c) { spots.push({ before: c, foot: c.parentElement }); });
    spots = spots.filter(function (s) { return s.foot && !s.foot.querySelector('.ia-k7'); });
    if (!spots.length || bagBusy) return;
    bagBusy = true;
    inEU().then(function (ok) {
      if (!ok) return;
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var items = (cart.items || []).filter(function (it) { return MAP[it.handle]; });
        if (!items.length) return;
        var sig = items.map(function (it) { return it.key + 'x' + it.quantity; }).join(',');
        if (sig === dismissed) return;
        return Promise.all(items.map(function (it) { return k7(MAP[it.handle]).then(function (p) { return { it: it, p: p, v: matchVariant(it, p) }; }); }))
          .then(function (rows) {
            var live = rows.some(function (r) { return r.p; });
            var good = rows.filter(function (r) { return live ? (r.v && r.v.available) : true; });
            if (!good.length) return;
            spots.forEach(function (s) { if (!s.foot.querySelector('.ia-k7')) s.before.parentNode.insertBefore(bagBox(good, live, rows.length, sig), s.before); });
          });
      });
    }).catch(function () {}).then(function () { bagBusy = false; });
  }
  function bagBox(good, live, total, sig) {
    var box = document.createElement('div');
    box.className = 'ia-k7';
    var n = good.length, all = n === total;
    var names = good.map(function (r) { var t = r.it.product_title.split(' - '); return esc(t.length > 1 ? t.slice(1).join(' - ') : r.it.product_title) + (r.it.variant_title && r.it.variant_title !== 'Default Title' ? ', ' + esc(r.it.variant_title) : ''); });
    var lead = '<p><strong>Ordering from the EU or UK?</strong> ' + (n === 1 ? (all ? 'This record is' : 'One of these records is') : (all ? 'These records are' : n + ' of these records are')) + ' at our EU/UK store: ' + PITCH + '</p>';
    if (!all) lead += '<ul class="ia-k7__list">' + names.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>';
    if (live && good.every(function (r) { return r.v; })) {
      var href = STORE + '/cart/' + good.map(function (r) { return r.v.id + ':' + r.it.quantity; }).join(',') + '?' + UTM;
      box.innerHTML = lead + '<a class="ia-k7__btn" href="' + esc(href) + '" target="_blank" rel="noopener">Check out ' + (n === 1 ? (all ? 'it' : 'this one') : (all ? 'them' : 'these ' + n)) + ' on our EU/UK store</a>' + (TEST ? '<p class="ia-k7__test">Test: live stock check worked.</p>' : '');
      box.querySelector('.ia-k7__btn').addEventListener('click', function () { setTimeout(function () { offerRemove(box, good, sig); }, 400); });
    } else {
      box.innerHTML = lead + good.map(function (r) { return '<a class="ia-k7__link" href="' + esc(k7url(MAP[r.it.handle])) + '">' + esc(r.it.product_title) + ' at the EU/UK store <span aria-hidden="true">&rarr;</span></a>'; }).join('<br>') + (TEST ? '<p class="ia-k7__test">Test: live stock check could not run, so these are plain links.</p>' : '');
    }
    return box;
  }
  function offerRemove(box, good, sig) {
    box.innerHTML = '<p>Your EU/UK checkout opened in a new tab. Take ' + (good.length === 1 ? 'that record' : 'those records') + ' out of this bag?</p>' +
      '<div class="ia-k7__row"><button type="button" data-yes>Yes, remove ' + (good.length === 1 ? 'it' : 'them') + '</button><button type="button" data-no>Keep ' + (good.length === 1 ? 'it' : 'them') + '</button></div>';
    box.querySelector('[data-no]').addEventListener('click', function () { dismissed = sig; document.querySelectorAll('.ia-k7').forEach(function (b) { if (b !== box && b.closest('.npb__foot, .cart__footer, .drawer__footer, cart-drawer')) b.remove(); }); box.remove(); });
    box.querySelector('[data-yes]').addEventListener('click', function () {
      var updates = {};
      good.forEach(function (r) { updates[r.it.key] = 0; });
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          if (window.NPBag && document.querySelector('.npb:not([hidden])')) { box.remove(); NPBag.open(); }
          else location.reload();
        });
    });
  }

  /* Watch the page: pickers and bags are drawn on demand. */
  function scan() {
    var holder = document.querySelector('[data-ia-k7-product]');
    if (holder) single(holder, holder.getAttribute('data-ia-k7-product'), function (box) { holder.appendChild(box); holder.hidden = false; });
    document.querySelectorAll('.iaqa__card').forEach(function (card) {
      var d = card.querySelector('.iaqa__details');
      if (!d) return;
      var h = handleFromUrl(d.getAttribute('href'));
      if (card.__iaK7 && card.__iaK7 !== h) { var old = card.querySelector('.ia-k7'); if (old) old.remove(); card.__iaK7 = null; }
      single(card, h, function (box) { if (card.querySelector('.iaqa__details') === d) d.parentNode.insertBefore(box, d); });
    });
    bags();
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(scan, 120); }
  function start() {
    scan();
    if (window.MutationObserver) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
